import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAll_Shift_Report  = createAsyncThunk(
    'report/fetchAllShift',
    async ( year : any , { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/shift/employeecount?year=${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Shift Report');
        }
    }
);
export const fetchAll_Employee_shift_Details  = createAsyncThunk(
    'report/fetchAllEmployeeShift',
    async ( { year , month } : any , { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/shift/employeeshift?year=${year}&month=${month}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Shift Report');
        }
    }
);
export const fetchAll_Shift_Count  = createAsyncThunk(
    'report/fetchAllEmployeeShiftCount',
    async ( _, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/shift/dashboard`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Shift Report');
        }
    }
);